'use strict';
var populationElements = document.querySelectorAll('.population');
var total = 0;
populationElements.forEach(function(el) {
    var num = Number(el.innerText.replace(/,/g, ''));
    if (!isNaN(num)) total += num;
});
var average = Math.round(total / populationElements.length);
document.querySelector('.total-population').innerText = total.toLocaleString('en-US');
document.querySelector('.average-population').innerText = average.toLocaleString('en-US');

//# sourceMappingURL=js_get_data_DOM.79f66043.js.map
